@file:kotlin.js.JsExport
package com.narbase.letsgo.web.dto.ridephonenumber
import com.narbase.letsgo.dto.core.KmmLong
data class RidePhoneNumberDto(
    val id: KmmLong?,
    val rideId: KmmLong,
    val callingCode: String,
    val phone: String,
)

data class PhoneNumberDto(
    val callingCode: String,
    val phone: String,
)